import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from '../styles.module.scss'

export const TextLandDe = () => {
    const isDesktop = useMediaQuery('(min-width: 1024px)')

    return (
        <HighlightedText
            text="325% BONUS BIS ZU 5.000 € + 400 FREISPIELE"
            highlights={[
                { word: '325%' },
                { word: '5.000 €' },
                { word: '400' },
            ]}
            breakAfterWords={isDesktop ? ['BONUS', '5.000 €'] : ['5.000 €']}
            className={styles.text_land}
        />
    )
}
